import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-icon-zuojiantou",
  "use": "icon-icon-zuojiantou-usage",
  "viewBox": "0 0 57 12",
  "content": "<symbol viewBox=\"0 0 57 12\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-icon-zuojiantou\">\r\n<path d=\"M0 6L10 11.7735V0.226497L0 6ZM57 5L9 5V7L57 7V5Z\" fill=\"#E32631\" />\r\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol